import React, { FC, memo, ReactElement } from 'react';
import { useFormikContext } from "formik";
import { TrainingPlanFormValues } from "../trainingPlan.types";
import { ExerciseItem } from "./ExerciseCardItem";

type ExerciseCardProps = {
  tabIndex: number;
};

export const ExerciseCard: FC<ExerciseCardProps> = ({ tabIndex }: ExerciseCardProps): ReactElement => {
  const { values } = useFormikContext<TrainingPlanFormValues>();
  
  return (
    <>
      {values.trainings[tabIndex].exercises.map((_, index) => {
        return (
          <ExerciseItem key={`${index}-${tabIndex}`} index={index} tabIndex={tabIndex}/>
        );
      })}
    </>
  );
};

export default ExerciseCard;
